import { getStyles } from '../styled/AvatarItem';
import styledCache from './styledCache';
export default styledCache(getStyles);
//# sourceMappingURL=getStyledAvatarItem.js.map